(() => {
  const initialize = () => {
    const tabs = document.querySelector('[data-fitcook-tabs]');
    const catalog = document.querySelector('[data-fitcook-catalog]');
    if (!tabs || !catalog || tabs.dataset.initialized) return;
    tabs.dataset.initialized = 'true';
    const links = [...tabs.querySelectorAll('[data-fitcook-filter]')];
    const groups = [...catalog.querySelectorAll('[data-fitcook-group]')];
    const select = (key, scroll) => {
      if (key !== 'all' && !groups.some(group => group.dataset.fitcookGroup === key)) return;
      groups.forEach(group => { group.hidden = key !== 'all' && group.dataset.fitcookGroup !== key; });
      links.forEach(link => {
        const active = link.dataset.fitcookFilter === key;
        link.classList.toggle('is-active', active);
        link.setAttribute('aria-current', active ? 'true' : 'false');
      });
      catalog.classList.toggle('is-filtered', key !== 'all');
      if (scroll) catalog.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    };
    links.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      select(link.dataset.fitcookFilter, true);
      history.replaceState(null, '', link.getAttribute('href'));
    }));
    const restore = () => {
      const hash = location.hash;
      if (hash.startsWith('#fitcook-group-')) select(hash.slice('#fitcook-group-'.length), false);
      else if (hash === '#fitcook-flavours') select('all', false);
    };
    restore();
    window.addEventListener('hashchange', restore);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
